module.exports = __webpack_public_path__ + "static/media/8.f47e1c10.jpg";